module.exports = __webpack_public_path__ + "img/4.Porsche2018.221abf13.png";